export const API = {
  LAST_RUN_DATE: "monitoring/api/background-task/get-last-run-date/",
  NEW_PIPELINE: "monitoring/api/execute-pipeline/",
  PIPELINE_LIST: "monitoring/api/pipeline-list",
  USECASE_OPTIONS: "monitoring/api/use-case/",
  MARKET_FILTER: "monitoring/api/market-place/",
  ClUSTER_MEMORY_CHART: "monitoring/api/cluster-data/",
  REFRESH: "monitoring/api/background-task/data-refresh-job",
  REFRESH_STATUS: "monitoring/api/background-task/get-data-refresh-status",
  CALENDAR_REFRESH_DATA: "monitoring/api/calendar-refresh-data",
  FLOW_DIAGRAM: "monitoring/api/pipeline-diagram",
  DEEP_DIVE: "monitoring/api/pipeline-deep-dive-data/",
  NEW_PIPELINE_CONFIG: "monitoring/api/get-config-data/",
  RAW_DATA_QUALITY: "data_metadata/api/raw-data-quality/",
  FLOW_DIAGRAM_V2: "monitoring/api/pipeline-diagram",
  PIPELINE_NAMES_LIST: "monitoring/api/pipeline-list-info/",
  DATA_METADATA_PIPELINE_NAME_AND_RUN_ID:
    "data_metadata/api/filter-pipeline-run-id-list/",
  SCHEDULE_PIPLINE: "monitoring/api/schedule-pipeline/",
  RUN_PIPELINE: "monitoring/api/execute-pipeline/",
  UPDATE_NEWPIPELINE_CONFIG: "monitoring/api/update-config-data/",
  METADATA: "data_metadata/api/cards-table-info/",
  RAW_DATA_INFO: "data_metadata/api/raw-data-info/",
  RAW_DATA_CSV_DOWNLOAD: "data_metadata/api/raw-data-download-files/",
  MODEL_META_DATA_CARDS: "model_metadata/api/tiles-data/",
  MODEL_META_DATA_TABLE: "model_metadata/api/table-data/",
  MODEL_META_DATA_CHART: "model_metadata/api/trends-chart-data/",
  DATA_META_DATA_EMAIL_TRIGER: "data_metadata/api/email-trigger-info/",
  MAINTENANCE_LIST: "maintenance/api/pipeline-last-run/",
  MAINTENANCE_EXECUTION_HISTORY: "maintenance/api/pipeline-execution-history/",
  MAINTENANCE_CHART: "maintenance/api/pipeline-execution-count/",
  SCHEDULE_DEFAULT_RUN: "maintenance/api/schedule-pipeline-trigger/",
  MAINTENANCE_GET_DEFAULT_CONFIG: "maintenance/api/get-default-config/",
  MAINTENANCE_LAST_MODIFIED_DATE:
    "maintenance/api/config-file-last-modified-date/",
  HARMONIZATION_GET_SCENARIO_LIST: "data-harmonization/get-scenario-list/",
  HARMONIZATION_GET_DATASET_LIST: "/data-harmonization/get-dataset-list/",
  HARMONIZATION_GET_DATASET_TABLE: "/data-harmonization/get-dataset-table/",
  // HARMONIZATION_MAP_COLUMNS: "/data-harmonization/create-mapping-scenario/",
  HARMONIZATION_MAP_COLUMNS: "/data-harmonization/create-table-mappings/",
  HARMONIZATION_SCENARIO_DETAILS : "data-harmonization/get-scenario-details/",
  HARMONIZATION_DELETE_SCENARIO: "/data-harmonization/delete-mapping-scenario/",
  GET_PARAMETERS_FOR_PIPELINE: "/monitoring/api/get-pipeline-parameters/",
  UPDATE_PARAMETERS_FOR_PIPELINE: "/monitoring/api/update-pipeline-parameters/",
}
